import Types from "./Types";

const INITIAL_STATE = {
  dashboardData: null,
  bestSellingProducts: null,
  salesReport: null,
  soldQuantitiesReport: null,
  vatReport: null,
  isLoading: false,
};

const dashboardReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case Types.DASHBOARD_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case Types.GET_DASHBOARD_DATA_SUCCESS:
      return {
        ...state,
        dashboardData: action.payload.data,
        isLoading: false,
      };
    case Types.GET_BEST_SELLING_PRODUCTS_SUCCESS:
      return {
        ...state,
        bestSellingProducts: action.payload,
        isLoading: false,
      };
    case Types.GET_SALES_REPORT_SUCCESS:
      return {
        ...state,
        salesReport: action.payload,
        isLoading: false,
      };
    case Types.GET_SOLD_QUANTITIES_REPORT_SUCCESS:
      return {
        ...state,
        soldQuantitiesReport: action.payload,
        isLoading: false,
      };
    case Types.GET_VAT_REPORT_SUCCESS:
      return {
        ...state,
        vatReport: action.payload,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default dashboardReducer;
